import React from 'react';

// Reusable Modal Component for Accreditation
const AccreditationModal = ({ isOpen, onClose, images, onImageClick }) => {
  if (!isOpen) return null;

  return (
    <div className="modal" style={modalStyle}>
      <span style={closeButtonStyle} onClick={onClose}>&times;</span>
      <div style={modalContentStyle}>
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Accreditation Letter ${index + 1}`}
            style={imageStyle}
            onClick={() => onImageClick(img)}
          />
        ))}
      </div>
    </div>
  );
};

// Styles for Modal
const modalStyle = {
  display: 'flex',
  position: 'fixed',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  justifyContent: 'center',
  alignItems: 'center',
};

const modalContentStyle = {
  maxWidth: '90%',
  maxHeight: '80%',
  overflowY: 'auto',
};

const imageStyle = {
  width: '100%',
  height: 'auto',
  maxHeight: '100%',
};

const closeButtonStyle = {
  color: 'white',
  position: 'absolute',
  top: '20px',
  right: '40px',
  fontSize: '40px',
  fontWeight: 'bold',
  cursor: 'pointer',
};

export default AccreditationModal;